import { render } from "./NewsEducationView.vue?vue&type=template&id=760e944d"
import script from "./NewsEducationView.vue?vue&type=script&lang=js"
export * from "./NewsEducationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__